import { getStore } from '~/mobx/AppStore';

export const getIsLoading = () => {
    const { adminStore, companyStore } = getStore();
    const isLoading =
        adminStore.isLoadingElectionAndRegions ||
        adminStore.isUpdatingElection ||
        adminStore.isCopyingElection ||
        companyStore.isGettingCompanyList;
    return isLoading;
};
